import { render } from "./AppLogin.vue?vue&type=template&id=2515832f"
import script from "./AppLogin.vue?vue&type=script&lang=js"
export * from "./AppLogin.vue?vue&type=script&lang=js"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__